import { create } from "zustand";

interface SubscriptionModal {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
}

const useSubscriptionModal = create<SubscriptionModal>((set) => ({
  isOpen: false,
  toggle: () => set((state: any) => ({ isOpen: !state.isOpen })),
  open: () => set((state: any) => ({ isOpen: true })),
}));

export default useSubscriptionModal;
